// extracted by mini-css-extract-plugin
export default {"handle":"ResizeHandle_handle__CpjBM","active":"ResizeHandle_active__qOA7q"};